import React, { useEffect, useState, useRef } from "react";
import { Pilihan } from "./pilihan";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import useVerify from "./useVerify";

function QuizPage() {
  useVerify("user");

  const location = useLocation();
  const { baseQuestion, quizId } = location.state;
  const [missingOptions, setMissingOptions] = useState([]);
  const [currentFive, setCurrentFive] = useState([]);

  const [rightAnswer, setRightAnswer] = useState(0);

  const [time, setTime] = useState(60);
  const [intervalId, setIntervalId] = useState(null);

  const [sesi, setSesi] = useState(0);

  const [totalCorrect, setTotalCorrect] = useState(0);
  const [listCorrect, setListCorrect] = useState([]);

  const navigate = useNavigate();

  const [account, setAccount] = useState({});

  const [saveQuestions, setSaveQuestions] = useState([[]]);
  const [answerUser, setAnswerUser] = useState([[]]);
  const [correctUser, setCorrectUser] = useState([[]]);

  const [totalCorrectHasil, setTotalCorrectHasil] = useState(0);

  // Ref untuk akses nilai terbaru di dalam async function
  const saveQuestionsRef = useRef([[]]);
  const answerUserRef = useRef([[]]);
  const correctUserRef = useRef([[]]);

  useEffect(() => { saveQuestionsRef.current = saveQuestions; }, [saveQuestions]);
  useEffect(() => { answerUserRef.current = answerUser; }, [answerUser]);
  useEffect(() => { correctUserRef.current = correctUser; }, [correctUser]);

  useEffect(() => {
    setAccount(JSON.parse(Cookies.get("account")));
  }, []);

  // Generate soal baru setiap ganti sesi
  useEffect(() => {
    generateSesiQuestion();

    const id = setInterval(() => {
      setTime((time) => time - 1);
    }, 1000);
    setIntervalId(id);

    return () => clearInterval(id);
    // eslint-disable-next-line
  }, [sesi, baseQuestion]);

  // Cek waktu habis
  useEffect(() => {
    if (time === 0) {
      const newList = listCorrect.concat(totalCorrect);
      setListCorrect(newList);

      if (sesi < baseQuestion.length - 1) {
        // Belum sesi terakhir — lanjut sesi berikutnya
        setTotalCorrect(0);
        setTime(60);
        setSesi((sesi) => sesi + 1);
      } else {
        // Sesi terakhir selesai
        clearInterval(intervalId);

        // Navigate LANGSUNG ke result dulu agar user tidak menunggu
        navigate("/result", {
          state: { listCorrect: newList },
        });

        // Simpan data ke server di background (tidak menunggu)
        simpanHasil(newList);
      }
    }
    // eslint-disable-next-line
  }, [time]);

  // Fungsi simpan hasil — dijalankan di background setelah navigate
  function simpanHasil(newList) {
    const acc = JSON.parse(Cookies.get("account"));

    fetch(`${process.env.REACT_APP_BASE_URL}/api/add_hasil`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        userId: acc.userId,
        quizId: quizId,
        totalCorrectHasil: totalCorrectHasil,
      }).toString(),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.hasilId) {
          simpanKolomAnswers(data.hasilId, newList);
        }
      })
      .catch((err) => console.error("Error simpan hasil:", err));
  }

  function simpanKolomAnswers(hasilId, kolomAnswer) {
    kolomAnswer.forEach((input, index) => {
      fetch(`${process.env.REACT_APP_BASE_URL}/api/add_kolom_answer`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          hasilId: hasilId,
          kolomId: baseQuestion[index].kolomId,
          totalCorrectKolom: input,
        }).toString(),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.kolomAnswerId) {
            simpanJawabans(data.kolomAnswerId, index);
          }
        })
        .catch((err) => console.error("Error simpan kolom answer:", err));
    });
  }

  function simpanJawabans(kolomAnswerId, index) {
    const sq = saveQuestionsRef.current;
    const au = answerUserRef.current;
    const cu = correctUserRef.current;

    if (!sq[index]) return;

    sq[index].forEach((input, idx) => {
      fetch(`${process.env.REACT_APP_BASE_URL}/api/add_jawaban`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          kolomAnswerId: kolomAnswerId,
          question: input,
          answer: au[index]?.[idx] ?? "",
          correct: cu[index]?.[idx] ?? 0,
        }).toString(),
      })
        .then((response) => response.json())
        .catch((err) => console.error("Error simpan jawaban:", err));
    });
  }

  // Generate 5 item fixed untuk tabel hitam — dipanggil hanya saat ganti sesi
  function generateSesiQuestion() {
    const shuffled = _.shuffle(baseQuestion[sesi].kolom);
    const fiveRandom = shuffled.slice(0, 5);
    setCurrentFive(fiveRandom);
    generateMissingOption(fiveRandom);
  }

  // Generate kotak biru (4 item) — dipanggil setiap user jawab
  function generateMissingOption(five = currentFive) {
    const randomTmp = Math.floor(Math.random() * 5);
    setRightAnswer(randomTmp);

    const displayed = five.filter((_, idx) => idx !== randomTmp);
    setMissingOptions(_.shuffle(displayed));
  }

  const handleChange = (value) => {
    const userAnswer = value;

    if (userAnswer === rightAnswer) {
      setTotalCorrect((totalCorrect) => totalCorrect + 1);
      setTotalCorrectHasil((totalCorrectHasil) => totalCorrectHasil + 1);
      setCorrectUser(handleSaveState(correctUser, 1));
    } else {
      setCorrectUser(handleSaveState(correctUser, 0));
    }

    setAnswerUser(handleSaveState(answerUser, currentFive[userAnswer]));
    setSaveQuestions(handleSaveState(saveQuestions, missingOptions));

    generateMissingOption();
  };

  function handleSaveState(array, newItem) {
    const newSaveState = [...array];
    if (!newSaveState[sesi]) newSaveState[sesi] = [];
    newSaveState[sesi].push(newItem);
    return newSaveState;
  }

  return (
    <div className="container mx-auto p-4 max-w-lg">
      <img
        className="mt-8 mb-12 mx-auto h-20 w-auto"
        src="./assets/img/logo-oc-1.png"
        alt="OWL Course"
      />
      <h1 className="text-4xl font-bold ml-4 mb-3 text-[#FF914D]">
        Quiz Kecermatan
      </h1>
      <p className="ml-4">Total benar : {totalCorrect}</p>
      <form className="p-4">
        <label className="block font-bold mb-2">
          {time > 0
            ? `${Math.floor(time / 60)}:${
                time % 60 < 10 ? `0${time % 60}` : time % 60
              }`
            : "Waktu habis"}
        </label>

        {/* Tabel hitam - 5 item FIXED selama 1 sesi */}
        <table className="w-full border-[#3F3B3C] border-[1px] rounded-lg mb-4">
          <tbody>
            <tr>
              {currentFive.map((option, idx) => (
                <td
                  key={idx}
                  className="border-[#3F3B3C] border-[1px] p-2 text-center text-3xl font-bold"
                >
                  {option}
                </td>
              ))}
            </tr>
            <tr>
              {["A", "B", "C", "D", "E"].map((label) => (
                <td
                  key={label}
                  className="border-[#3F3B3C] border-[1px] p-2 text-center"
                >
                  {label}
                </td>
              ))}
            </tr>
          </tbody>
        </table>

        {/* Kotak biru - 4 item yang berubah setiap soal */}
        <div className="w-full p-4 flex gap-4 justify-center rounded-lg border-blue-500 border-2 mb-4">
          {missingOptions.map((option, idx) => (
            <div key={idx} className="font-bold text-blue-500 text-xl">
              {option}
            </div>
          ))}
        </div>

        <div className="flex gap-2 justify-center">
          <Pilihan value={0} handleChange={handleChange} />
          <Pilihan value={1} handleChange={handleChange} />
          <Pilihan value={2} handleChange={handleChange} />
          <Pilihan value={3} handleChange={handleChange} />
          <Pilihan value={4} handleChange={handleChange} />
        </div>
      </form>
    </div>
  );
}

export default QuizPage;
